import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { ActionStatus } from '@pixacare/shared';
import { downloadBlob } from '@shared/utils/utils';
import { ErrorIconComponent } from '@shared/components/error-icon/error-icon.component';
import { TuiButton, TuiHint, TuiIcon } from '@taiga-ui/core';
import { FormInstanceStatus } from '../models/form-instance-status';

@Component({
  selector: 'pxc-form-instance-status-icon',
  templateUrl: './form-instance-status-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'inline-flex',
  },
  imports: [ErrorIconComponent, TranslocoDirective, TuiButton, TuiHint, TuiIcon],
})
export class FormInstanceStatusIconComponent {
  readonly status = input<FormInstanceStatus | undefined>(undefined);
  readonly exportData = input<object | undefined>(undefined);

  protected readonly ActionStatus = ActionStatus;
  protected readonly state = computed(() => this.status()?.state);
  protected readonly errorMessage = computed(() => this.status()?.message ?? '');

  protected downloadExportData(): void {
    const data = this.exportData();
    if (!data) {
      return;
    }
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    downloadBlob(blob, `pixacare-support-${Date.now()}.json`);
  }
}
